<div class="dialog-content">
  <form class="k-form" [formGroup]="operatingCostsForm">
    <kendo-formfield orientation="horizontal">
      <kendo-label class="!k-align-items-start" [for]="identifier" text="Bezeichnung"></kendo-label>
      <kendo-textbox [formControlName]="formControlNames.Identifier" #identifier> </kendo-textbox>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="invoicedSinceDate" text="Datum"></kendo-label>
      <kendo-datepicker
        [formControlName]="formControlNames.Date"
        #invoicedSinceDate
      ></kendo-datepicker>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label
        class="!k-align-items-start"
        [for]="budgetPerTask"
        [text]="'Betrag'"
      ></kendo-label>
      <div class="k-d-flex">
        <span class="prefix-currency">&euro;</span>
        <kendo-numerictextbox
          [formControlName]="formControlNames.Amount"
          #budgetPerTask
          [spinners]="false"
          format="m2"
        >
        </kendo-numerictextbox>
      </div>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label class="!k-align-items-start" [for]="supplier" text="Lieferant"></kendo-label>
      <kendo-textbox [formControlName]="formControlNames.Supplier" #supplier> </kendo-textbox>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>

    <div
      class="k-d-grid"
      style="grid-template-columns: minmax(115px, max-content) auto; margin-bottom: 1.5rem"
    >
      <kendo-label class="!k-align-items-start k-align-self-center" text="Tags"></kendo-label>
      <app-shive-taglist [(selectedTags)]="selectedTags" />
    </div>

    <kendo-formfield orientation="horizontal">
      <kendo-label
        class="!k-align-items-start"
        [for]="formControlNames.Due"
        text="Zahlungsziel"
      ></kendo-label>
      <kendo-datepicker [id]="formControlNames.Due" [formControlName]="formControlNames.Due" #due>
      </kendo-datepicker>
      <kendo-formerror>Error: Username is required</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label
        class="!k-align-items-start"
        [for]="recurrence"
        text="Wiederholung"
      ></kendo-label>
      <kendo-dropdownlist
        [data]="recurrenceOptions()"
        textField="text"
        valueField="value"
        [formControlName]="formControlNames.Recurrence"
        #recurrence
      >
      </kendo-dropdownlist>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label
        class="!k-align-items-start"
        [for]="formControlNames.RecurrenceEnd"
        text="Ende"
      ></kendo-label>
      <kendo-datepicker
        [id]="formControlNames.RecurrenceEnd"
        [formControlName]="formControlNames.RecurrenceEnd"
        #recurrenceEnd
      >
      </kendo-datepicker>
      <kendo-formerror>Error: Username is required</kendo-formerror>
    </kendo-formfield>

    <div
      class="k-d-grid k-align-items-center"
      style="
        grid-template-columns: minmax(117px, max-content) auto;
        margin-bottom: 1.5rem;
        height: 40px;
      "
    >
      <kendo-label text="Bezahlt" [for]="isPaid"></kendo-label>
      <div class="k-form-field-checkbox-wrap">
        <input #isPaid type="checkbox" kendoCheckBox [formControlName]="formControlNames.IsPaid" />
      </div>
    </div>

    <kendo-fileselect [formControlName]="formControlNames.Attachment" [multiple]="false">
      <ng-template kendoFileSelectFileInfoTemplate let-file>
        <a class="k-link k-ml-2" (click)="downloadFile()" title="Download">
          <span class="k-file-name">{{ file[0].name }}</span>
        </a>
      </ng-template>
    </kendo-fileselect>
  </form>
</div>

<footer #dialogFooter class="k-d-flex k-justify-content-between">
  <button (click)="close()" kendoButton size="large" themeColor="secondary" class="k-mr-4 !k-pr-4">
    <span class="custom-symbol close k-mr-3"></span>
    <span class="label">Schließen</span>
  </button>

  <button kendoButton (click)="submit()" class="!k-pr-4" themeColor="base" size="large">
    <fa-icon class="add k-text-white k-mr-3" [icon]="faCirclePlus"></fa-icon>
    <span class="label">
      {{ operatingCosts().id && operatingCosts().id >= 0 ? "Aktualisieren" : "Speichern" }}</span
    >
  </button>
</footer>
